export enum ContentType {
  Story = 'story',
  Sounds = 'sounds',
  Soul = 'soul',
  Series = 'series',
}
